/**
 * Money is stored and computed as integer **fils**. 1 JOD = 1000 fils (the Jordanian
 * Dinar has 3 decimal places). Never use floats for money.
 */
export const FILS_PER_JOD = 1000;

/** 5.5 JOD -> 5500 fils. Rounds to the nearest fil. */
export function jod(amount: number): number {
  return Math.round(amount * FILS_PER_JOD);
}

/** 5500 fils -> "5.500". */
export function formatJod(fils: number, withCurrency = false): string {
  const sign = fils < 0 ? "-" : "";
  const abs = Math.abs(Math.trunc(fils));
  const whole = Math.floor(abs / FILS_PER_JOD);
  const frac = String(abs % FILS_PER_JOD).padStart(3, "0");
  const text = `${sign}${whole.toLocaleString("en-US")}.${frac}`;
  return withCurrency ? `${text} JOD` : text;
}

/** Parses "5.5", "5.500 JOD" or "1,845.500" into fils. Returns NaN when invalid. */
export function parseJod(input: string): number {
  const cleaned = input.replace(/JOD/gi, "").replace(/,/g, "").trim();
  if (!/^-?\d+(\.\d{1,3})?$/.test(cleaned)) return Number.NaN;
  return jod(Number(cleaned));
}

/** Basis-point percentage (1600 bp = 16%) applied to an amount in fils, rounded half-up. */
export function applyBasisPoints(fils: number, basisPoints: number): number {
  return Math.round((fils * basisPoints) / 10_000);
}
